<template>
  <v-container class="agreements-callouts" v-if="showSuccess || showWarning">
    <v-layout>
      <v-flex>
        <Alert v-if="showSuccess" type="success" @close="$emit('closeSuccess')">
            {{successMessage}}
            <ul v-if="signedAgreements.length > 0">
              <li v-for="agreement in signedAgreements" :key="agreement.id">
                <em>{{agreement.title}}</em>
              </li>
            </ul>
        </Alert>

        <Alert
          v-if="showWarning"
          lead-in="One or more agreements were declined"
          type="warning"
          @close="$emit('closeWarning')">
          <ul v-if="declinedAgreements.length > 0">
            <li v-for="agreement in declinedAgreements" :key="agreement.id">
              <em>{{agreement.title}}</em>
            </li>
          </ul>
          <span v-if="inspectorPhoneNumber">
            Please contact your inspector with any questions
            (<a :href="`tel:${inspectorPhoneNumber}`">{{inspectorPhoneNumber}}</a>).
          </span>
        </Alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Alert from '@/components/Shared/Alert.vue';

export default {
  components: {
    Alert,
  },
  props: {
    agreements: {
      type: Array,
      default: () => [],
    },
    inspectorPhoneNumber: {
      type: String,
      default: '',
    },
    showSuccess: {
      type: Boolean,
      default: false,
    },
    showWarning: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    declinedAgreements() {
      return this.agreements.filter(agreement => agreement.status === 'DECLINED');
    },
    signedAgreements() {
      return this.agreements.filter(agreement => agreement.status === 'SIGNED');
    },
    successMessage() {
      if (this.signedAgreements.length === 0) return '';
      const messagePrefix = this.signedAgreements.length > 1 ? 'Agreements' : 'Agreement';
      return `${messagePrefix} successfully signed:`;
    },
  },
};
</script>
